var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"booking-organized-groups"}},[_c('a',{staticClass:"book",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Бронировать")]),_vm._v(" "),_c('registration-form',{attrs:{"show-modal":_vm.showModal,"id":_vm.turID,"is-individual":_vm.isIndividual,"date-start":_vm.turDateStart,"date-end":_vm.turDateEnd},on:{"close":_vm.closeModal,"cancel":_vm.closeModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc190b0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Index.vue
// module id = 88
// module chunks = 0